import React, { useContext, useState } from "react";
import "./index.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import UserContext from "../../context/userContext";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";

import { DatePicker } from "@mui/x-date-pickers";

const paymentData = [
  {
    id: 1,
    month: "August payment",
    status: "Deposited",
    date: "03-Jan-2022",
    money: "LKR2500",
  },
  {
    id: 2,
    month: "September payment",
    status: "Deposited",
    date: "03-Jan-2022",
    money: "LKR3000",
  },
  {
    id: 3,
    month: "October payment",
    status: "Pending",
    date: "03-Jan-2022",
    money: "LKR3500",
  },
  {
    id: 4,
    month: "November payment",
    status: "Deposited",
    date: "03-Jan-2022",
    money: "LKR2500",
  },
];

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#ffffff",
  color: "#8f8f8f",
  boxShadow: "1px 1px 1px 1px #d1d1d1",
  // '&:hover': {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginRight: theme.spacing(2),
  width: "100%",
  height: "50px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(5),
    width: "70%",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.5, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "30ch",
    },
  },
}));

export const PaymentHistory = () => {
  const navigate = useNavigate();
  let userValue = useContext(UserContext);
  let { user_id, user_type } = userValue;
  const [input, setinput] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dateFrom, setDateFrom] = React.useState(null);
  const [dateTo, setDateTo] = React.useState(null);
  const color = "#677294";
  let outputarray = paymentData.filter((item) => {
    return Object.keys(item).some((key) =>
      item[key]
        .toString()
        .toLowerCase()
        .includes(input.toString().toLowerCase())
    );
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpenDrawer({ ...openDrawer, [anchor]: open });
  };
  return (
    <>
      {/* setting drawer */}
      <div>
        <React.Fragment>
          <Drawer
            anchor={"right"}
            open={openDrawer["right"]}
            onClose={toggleDrawer("right", false)}
          >
            <>
              <div className="filter-drawer-main">
                <div
                  className="close-icon"
                  onClick={toggleDrawer("right", false)}
                >
                  <CloseIcon />
                </div>
                <p className="filter-heading">Search by Filter</p>
                <DatePicker
                  label="From"
                  value={dateFrom}
                  onChange={(newValue) => {
                    setDateFrom(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="date-picker"
                      sx={{
                        svg: { color },
                        input: { color },
                        label: { color },
                      }}
                    />
                  )}
                />
                <DatePicker
                  label="To"
                  value={dateTo}
                  onChange={(newValue) => {
                    setDateTo(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="date-picker"
                      sx={{
                        svg: { color },
                        input: { color },
                        label: { color },
                      }}
                    />
                  )}
                />
                <div className="filter-dropdown">
                  <select name="price" id="price">
                    <option value="price Low">Price Low to High</option>
                    <option value="price high">Price High to Low</option>
                  </select>
                  <select name="payments" id="payments">
                    <option value="Pending Payments">Pending Payments</option>
                    <option value="Deposited">Deposited</option>
                  </select>
                </div>
              </div>
              <div className="drawer-btn">
                <Button variant="contained">Reset</Button>
                <Button variant="contained">Done</Button>
              </div>
            </>
          </Drawer>
        </React.Fragment>
      </div>

      <div className="paymentMain">
        <Grid container>
          <Grid item xs={5} md={6} lg={7}>
            <div className="mainHeading">
              <div onClick={() => navigate(-1)}>
                <ArrowCircleLeftOutlinedIcon
                  className="headingIcon"
                  fontSize="large"
                />
              </div>
              <h3>Monthly Payments</h3>
            </div>
          </Grid>
          {user_type === 4 ? (
            ""
          ) : (
            <>
              <Grid item xs={5} md={5} lg={4}>
                <Search className="searchBox">
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder="Search…"
                    inputProps={{ "aria-label": "search" }}
                    value={input}
                    onChange={(e) => setinput(e.target.value)}
                  />
                </Search>
              </Grid>
              <Grid item xs={2} md={1} lg={1}>
                <div className="tuneIcon" onClick={toggleDrawer("right", true)}>
                  <TuneOutlinedIcon />
                </div>
              </Grid>
            </>
          )}
        </Grid>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            "& > :not(style)": {
              m: 1,
              mt: 0,
              width: "100%",
              height: "auto",
            },
          }}
        >
          <div className="scroll">
            {Object.keys(outputarray).map((keyName) => {
              const payment = outputarray[keyName];
              return (
                <Link to="monthly-earning" className="paymentHistoryLink">
                  <div key={keyName}>
                    <Paper elevation={1} className="paymentData">
                      <Grid container>
                        <Grid item xs={5} md={6} lg={user_type === 4 ? 6 : 9}>
                          <div className="paymentMonth">
                            <h6>{payment.month}</h6>
                          </div>
                        </Grid>
                        <Grid item xs={3} md={2} lg={user_type === 4 ? 2 : 1}>
                          <div className="paymentDate">
                            <p>Date</p>
                            <h6>{payment.date}</h6>
                          </div>
                        </Grid>
                        <Grid item xs={2} md={2} lg={user_type === 4 ? 2 : 1}>
                          <div className="paymentMoney">
                            <h6>{payment.money}</h6>
                          </div>
                        </Grid>
                        <Grid item xs={2} md={2} lg={user_type === 4 ? 2 : 1}>
                          <div
                            className={
                              payment.status === "Deposited"
                                ? "paymentStatus"
                                : "paymentStatus2"
                            }
                          >
                            <h6>{payment.status}</h6>
                          </div>
                        </Grid>
                      </Grid>
                    </Paper>
                  </div>
                </Link>
              );
            })}
          </div>
        </Box>
      </div>
    </>
  );
};
